<template>
  <v-card class="pa-4">
    <manage-advertising>
      <template v-slot:tabs>
        <v-tab> مدیریت رزروها </v-tab>
      </template>
      <template v-slot:items>
        <v-tab-item>
          <commercialListItemSevenAdmin />
        </v-tab-item>
      </template>
    </manage-advertising>
  </v-card>
</template>

<script>
import manageAdvertising from "../../../../pages/qrland/components/qrManage/manageShop/manageAdvertising.vue";
import commercialListItemSevenAdmin from "../commercialListItemSeven/commercialListItemSevenAdmin.vue";
export default {
  components: { manageAdvertising, commercialListItemSevenAdmin },
  name: "commercialListItemSixAdmin",
};
</script>

<style></style>
